import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Field } from '../Field';
import { FormItem } from './FormItem';
import { VFFieldProps } from '../types';
import {
  CurrencyNumber as CurrencyNumberInput,
  formatFixedPointNumber,
} from '../move_me/CurrencyNumber';
import { Rifm } from 'rifm';
import { InputGroup } from '@mc/react-core';
import classNames from 'classnames';

export type NumProps = VFFieldProps<
  Omit<React.ComponentProps<typeof CurrencyNumberInput>, 'currency'>
>;
export const CurrencyNumber = React.forwardRef<HTMLInputElement, NumProps>(
  (
    {
      name,
      validate,
      className,
      onChange: customOnChange,
      inputClassName,
      label,
      disabled,
      required,
      precision = 2,
      ...other
    },
    ref
  ) => {
    return (
      <FormItem
        name={name}
        className={className}
        label={label}
        required={required}
        disabled={disabled}
      >
        <Field name={name} validate={validate}>
          {({
            input: { value, onChange, name, ...nother },
          }: FieldRenderProps<number>) => {
            return (
              <Rifm
                accept={/[\d.]/g}
                value={value === undefined ? '' : String(value)}
                onChange={onChange}
                format={(v) => formatFixedPointNumber(v, precision)}
              >
                {({ value, onChange }) => (
                  <InputGroup
                    className={classNames(inputClassName, 'bp3-fill')}
                    // @ts-ignore
                    ref={ref}
                    {...other}
                    {...nother}
                    disabled={disabled}
                    onChange={onChange}
                    maxLength={16}
                    value={value}
                  />
                )}
              </Rifm>
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
